import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DateService, DataService } from 'app/services';
import { ConfirmDismissDialogComponent, OverlayImageComponent } from 'app/modules/shared/components';
import { config, qualityMap } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import * as RecordRTC from 'recordrtc';
import { ToastrService } from 'ngx-toastr';
import { trim } from 'lodash';
import { TextareaComponent } from 'app/modules/shared/components/textarea/textarea.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inspection-category-item',
  templateUrl: './inspection-category-item.component.html',
  styleUrls: ['./inspection-category-item.component.scss'],
})
export class InspectionCategoryItemComponent implements OnInit, OnDestroy {
  @ViewChild('textAreaRef', { static: false }) textAreaComponent!: TextareaComponent;

  @Input() isFinalized: boolean;
  @Input() isArchived: boolean;
  @Input() inspectionItem: any = {};
  @Input() workStatus: string = '';
  @Input() inspectionStatus: string;
  @Input() screenWidth: number;

  isTextAreaActive: boolean = false;
  isUploading: boolean = false;
  isRecording: boolean = false;
  recorder: any = '';
  recordingTime: number = 0;
  intervalId: any = '';
  isProcessing: boolean = false;
  isEditMode: boolean = false;
  isEditorVisible: boolean = false;
  playingAudioIndex: any = -1;
  playingAudio: any;
  playingTime: any;
  playingIntervalId: any;
  fileTried: any = [];
  fileType: any = [];
  isDVICannedNotesEnabled = this.dataService.isDVICannedNotesEnabled;
  addMediaToInspectionEnabled = this.dataService.addMediaToInspections;;

  closeAfterAction = false;
  focusedFieldKey: string = 'outside';
  cannedNotes = [];
  dataSubscription: Subscription;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dialogService: DialogService,
    private toastrService: ToastrService,
    private dateService: DateService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    if (this.inspectionItem && this.inspectionItem.colorIndex >= 0) {
      this.showCannedNotes(this.inspectionItem);
      console.log('Archived', this.isArchived)
    }
    this.setDataService();
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }

  setDataService() {
    this.dataSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'delete-media') {
          const indexId = this.inspectionItem.attachments.findIndex((obj) =>
            obj.url === data.data.id);
          if (indexId !== -1 || indexId === 0) {
            this.deleteImage(indexId);
          }
        }
      }
    });

  }


  handleChange(key: string, value: any) {
    this.setFocus('outside');
    if (this.workStatus === 'inprogress') {
      return;
    }

    this.inspectionItem[key] = value;
    this.inspectionItem['notesCreatedAt'] = this.dateService.getCurrentDateTimeTz(new Date().getTime());
    if (key === 'colorIndex') {
      this.showCannedNotes(this.inspectionItem);
    }
  }

  handleAttachment() {
    this.setFocus('outside');
    if (this.workStatus === 'inprogress') {
      return;
    }
  }
  openImagePreview(attachment, type, attach) {
    this.setFocus('outside');
    let refined = [];
    attachment.map((val) => {
      if (val.type === type) {
        refined.push(val);
      }
    });
    this.dialogService.open(OverlayImageComponent, {
      data: {
        images: refined,
        index: attach.id || attach._id,
        url: attach.url,
        notes: attach.notes,
        status: this.workStatus,
        isShow: true,
        isFinalized: this.isFinalized
      },
      width: '100%',
      styleClass: 'lightgallery carousel-dialog',
      showHeader: true,
    });
  }

  handleFocusChange(type = 'outside', isActive: boolean) {
    this.setFocus(type);
    this.isTextAreaActive = isActive;
  }

  handleBrowse(fileUpload: HTMLElement) {
    this.setFocus('outside');
    if (this.inspectionStatus === 'inprogress') {
      return;
    }

    fileUpload.click();
  }
  uploadFile(event: any) {
    const files = event.target.files;
    if (files && files[0]) {
      let fileName: string = trim(files[0].name);
      fileName = fileName.replaceAll('-', '');
      const formData = new FormData();
      const selectedFile = files[0];
      const idxDot = selectedFile.name.lastIndexOf('.') + 1;
      const extFile = selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase();
      formData.append('file', files[0], fileName);

      if (this.helperService.isImageFile(extFile)) {
        //do whatever want to do
      } else {
        this.helperService.showToaster('error', 'Only images are allowed');
        return false;
      }
      const isDuplicate = this.fileTried.some(file =>
        file.lastModified === files[0].lastModified &&
        file === files[0].name?.split('-')?.join('')
      )
      if (isDuplicate) {
        this.helperService.showToaster('error', 'Duplicate file uploading is not allowed');
        return
      }
      this.fileTried.push(fileName);
      this.isUploading = true;
      this.httpService.uploadAttachment(formData, config.category.inspection, this.inspectionItem._id).then(
        (url: any) => {
          this.inspectionItem.attachments.push({
            name: url.url.split('/').pop(),
            type: 'image',
            url: url.url,
            createdBy: this.helperService.getCompany().userName,
            createdAt: url.uploadAt,
            createdAtTz: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(url.uploadAt).getTime()), datetimeFormat.mmmdyyhhmmaa),
          });
          this.isUploading = false;
        },
        (err) => {
          this.isUploading = false;
          this.helperService.showToaster('error', err);
        }
      );
    }
  }
  uploadVideoFile(event) {
    this.setFocus('outside');
    const files = event.target.files;
    if (files && files[0]) {
      const max_size = 35000000;
      const selectedFile = files[0];
      const idxDot = selectedFile.name.lastIndexOf('.') + 1;
      const extFile = selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase();
      const formData = new FormData();
      formData.append('file', files[0]);

      if (this.helperService.isVideoFile(extFile)) {
        //do whatever want to do
      } else {
        this.helperService.showToaster('error', 'Only videos are allowed');
        return false;
      }

      if (files[0].size > max_size) {
        this.helperService.showToaster('error', 'Maximum size allowed is ' + max_size / 1000000 + 'Mb');
        return false;
      }
      const isDuplicate = this.fileTried.some(file =>
        file.lastModified === files[0].lastModified &&
        file === files[0].name?.split('-')?.join('')
      )
      if (isDuplicate) {
        this.helperService.showToaster('error', 'Duplicate file uploading is not allowed');
        return
      }
      this.fileTried.push(files[0].name);
      this.httpService.uploadAttachment(formData, config.category.inspection, this.inspectionItem._id).then(
        (url: any) => {
          this.inspectionItem.attachments.push({
            videoSrc: url.url.split('/').pop(),
            type: 'video',
            url: url.url,
            createdBy: this.helperService.getCompany().userName,
            createdAt: url.uploadAt,
            createdAtTz: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(url.uploadAt).getTime()), datetimeFormat.mmmdyyhhmmaa),
          });
          this.isUploading = false;
        },
        (err) => {
          this.isUploading = false;
          this.helperService.showToaster('error', err);
        }
      );
    }
  }
  renderRecordingTime(time?) {
    if (time) {
      return this.helperService.getFormattedTime(time);
    }

    return this.helperService.getFormattedTime(this.recordingTime);
  }
  deleteAttachment(attachmentIndex, isForceDelete = false) {
    this.setFocus('outside');
    if (this.workStatus === 'inprogress') {
      return;
    }

    // if(!isForceDelete)
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete ${this.inspectionItem.attachments[attachmentIndex].type}`,
        message: `Are you sure you want to delete this ${this.inspectionItem.attachments[attachmentIndex].type}?`,
        button: {
          success: { title: 'Delete', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (this.inspectionItem.attachments[attachmentIndex].name) {
          const splittedArray = this.inspectionItem.attachments[attachmentIndex].name.split('-');
          if (splittedArray && splittedArray.length > 0) {
            let filename = decodeURIComponent(splittedArray[0]);
            const extSplittedArray = splittedArray[splittedArray.length - 1].split('.');
            if (extSplittedArray && extSplittedArray.length > 0) {
              filename = filename + '.' + extSplittedArray[extSplittedArray.length - 1];
            }
            const index = this.fileTried.findIndex((name: any) => name === filename);
            if (index > -1) {
              this.fileTried.splice(index, 1);
            }
          }
        }
        this.inspectionItem.attachments.splice(attachmentIndex, 1);
      }
      onClose.unsubscribe();
    });
  }

  deleteImage(attachmentIndex) {
    if (this.workStatus === 'inprogress') {
      return;
    }
    this.inspectionItem.attachments.splice(attachmentIndex, 1);
  }

  playAudio(audio, index) {
    this.setFocus('outside');
    if (this.playingAudioIndex > -1) {
      this.inspectionItem.attachments[this.playingAudioIndex].isPlaying = false;
      clearInterval(this.playingIntervalId);
      if (this.playingAudio) {
        this.playingAudio.pause();
      }
    }

    this.playingTime = 0;
    this.playingAudio = new Audio(audio.url);
    this.playingAudio.play();

    this.playingAudio.addEventListener('play', () => {
      this.playingIntervalId = setInterval(() => {
        if (this.playingTime < audio.recordingTime) {
          this.playingTime += 1;
        }
      }, 1000);
    });

    this.inspectionItem.attachments[index].isPlaying = true;
    this.playingAudio.addEventListener('ended', () => {
      this.inspectionItem.attachments[this.playingAudioIndex].isPlaying = false;
      clearInterval(this.playingIntervalId);
    });

    this.playingAudioIndex = index;
  }
  pauseAudio(audio, index) {
    this.setFocus('outside');
    clearInterval(this.playingIntervalId);
    this.playingAudio.pause();
    this.inspectionItem.attachments[index].isPlaying = false;
  }
  async recordVoice() {
    this.setFocus('outside');
    if (this.inspectionStatus === 'inprogress') {
      return;
    }
    this.isRecording = true;
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
    } catch (err) {
      this.isProcessing = false;
      this.isRecording = false;
      this.recordingTime = 0;
      this.toastrService.error('No recording device found');
      return;
    }
    this.recorder = RecordRTC(stream, {
      type: 'audio',
      mimeType: 'audio/wav',
      disableLogs: true,
    });
    this.recorder.startRecording();
    this.intervalId = setInterval(() => {
      this.recordingTime += 1;
    }, 1000);
  }

  async stopRecording(isSave) {
    this.setFocus('outside');
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    this.isRecording = false;
    if (!isSave) {
      this.isProcessing = false;
      this.recordingTime = 0;
    }
    clearInterval(this.intervalId);
    this.recorder.stopRecording(() => {
      if (isSave) {
        const blob = this.recorder.getBlob();
        const formData = new FormData();
        formData.append('file', blob);
        this.httpService.uploadAttachment(formData, config.category.inspection, this.inspectionItem._id).then(
          (res: any) => {
            this.inspectionItem.attachments.push({
              name: res.url.split('/').pop(),
              url: res.url,
              type: 'voice',
              recordingTime: this.recordingTime,
              createdBy: this.helperService.getCompany().userName,
              createdAt: res.uploadAt,
              createdAtTz: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(res.uploadAt).getTime()), datetimeFormat.mmmdyyhhmmaa),
            });
            this.recordingTime = 0;
            this.isProcessing = false;
          },
          (err) => {
            this.isProcessing = false;
            this.recordingTime = 0;
            this.helperService.showToaster('error', err);
          }
        );
      }
    });
  }

  isUploaded(inspectionItem: any, itemType: string) {
    let isUpload = false;
    if (inspectionItem && inspectionItem.length > 0) {
      inspectionItem.find((item) => {
        if (item.type === itemType) isUpload = true;
      });
    }
    return isUpload;
  }

  handleClearNotes() {
    this.cannedNotes.forEach((notes) => (notes.isChecked = false));
  }

  handleAddNotes() {
    const cannedNotes = [];
    this.cannedNotes.forEach((notes) => {
      if (notes.isChecked) {
        const length = this.inspectionItem?.notes?.length || 0;
        if (length < 500) {
          const diff = 500 - length;
          if (notes.note.length > diff) {
            notes.note = notes.note.substring(0, diff);
          }
          cannedNotes.push(`${notes.note}`);
        }
      }
    });
    if (cannedNotes && cannedNotes.length > 0) {
      if (this.focusedFieldKey === 'outside') {
        if (this.inspectionItem.notes) {
          this.inspectionItem.notes = `${this.inspectionItem.notes}\n\n${cannedNotes.join('\n\n')}`;
        } else {
          this.inspectionItem.notes = `${cannedNotes.join('\n\n')}`;
        }
      } else {
        this.inspectionItem.notes = this.helperService.insertTextInTextArea(this.textAreaComponent.textareaControl.nativeElement, ` ${cannedNotes.join('\n\n')}`);
      }
    }
    this.handleClearNotes();
  }

  checkNotesLength() {
    return this.cannedNotes && this.cannedNotes.filter((note) => note.isChecked).length;
  }

  onChange(note) {
    note.isChecked = !note.isChecked;
  }

  setFocus(type: string) {
    this.focusedFieldKey = type;
  }

  showCannedNotes(inspection) {
    let quality = null;
    quality = qualityMap[this.inspectionItem.colorIndex];
    const payload = {
      inspectionId: inspection.itemId,
      quality,
    };
    this.cannedNotes = [];
    this.httpService
      .getInspectionNotes(payload)
      .then(
        (notes: any[]) => {
          this.cannedNotes = notes;
          this.cannedNotes.forEach((note) => (note.isChecked = false));
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
      });
  }

  openCannedNotes() {
    this.closeAfterAction = !this.closeAfterAction;
  }
}
